import Stage1Player2Room from "../shared/Stage1Player2Room";

export default function Five_Players_Stage1_Player2(props) {
  return <Stage1Player2Room {...props} playerCount={5} showRegister={true} />;
}